const initialState = {
    anchor: 'left',
    empresa: [],
    open: false,
    id: '',
    nome: '',
    estoque_integrado: false,
    caminho_logo: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: ''
};

export function empresa(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_EMPRESA':
            return {
                ...state,
                empresa: action.empresa
            };
        case 'EMPRESA_DETAIL':
            return {
                ...state,
                id: action.id,
                nome: action.nome,
                estoque_integrado: action.estoque_integrado,
                caminho_logo: action.caminho_logo,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao
            };
        case "EMPRESA_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
